import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProductCluster } from "./UseProductCluster";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

export default function ProductCluster() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    getResultByID,
    ActiveCluster,
    getclusterList,
    deletecluster,
    SuspendCluster,
  } = UseProductCluster();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
    gridConf,
  } = UseMyPC();
  const [progress, setProgress] = useRecoilState(rsProgress);

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [clusterRes, setClusterRes] = useState();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
    type: undefined,
  });
  const [activeDialog, setActiveDialog] = useState({
    show: false,
    title: undefined,
    id: undefined,
    type: undefined,
  });

  const [suspendDialog, setSuspendDialog] = useState({
    show: false,
    title: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getclusterList(
      myPc,
      search,
      (productClusters) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(productClusters.pageCondition.totalPage);
          return;
        }
        setClusterRes(productClusters);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/productcluster/addCluster", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiDate",
      headerName: " تاریخ",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 1 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/productcluster/editCluster", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="نمایش">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setProgress(true);
                  getResultByID(cellValues.row.id, (callback) => {
                    window.open(callback, "_blank");
                  });
                }}
              >
                <InsertLinkIcon sx={{ width: "22px" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "وضعیت",
      sortable: false,
      width: 160,
      headerAlign: "center",
      headerName: "وضعیت",
      renderCell: (cellValues) => {
        return (
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setActiveDialog({
                  show: true,
                  title: cellValues.row.title,
                  id: cellValues.row.id,
                });
              }}
            >
              فروش
            </Button>
            <Button
              sx={{ ml: 1 }}
              color="secondary"
              variant="outlined"
              onClick={() => {
                setSuspendDialog({
                  show: true,
                  title: cellValues.row.title,
                  id: cellValues.row.id,
                });
              }}
            >
              تعلیق
            </Button>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productcluster" }],
      }}
    >
      {clusterRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={clusterRes.pageCondition.pageCount}
          rows={clusterRes.items}
          paginationMode="server"
          page={clusterRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={clusterRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              rowCount: clusterRes.pageCondition.totalItemCount,
              isLtr: true,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"خوشه"}
        callback={() => {
          setProgress(true);
          deletecluster(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          if (checkState.type == "available") {
            let sendState = {
              id: activeDialog.id,
              active: checkState.state,
            };
            ActiveCluster(sendState, () => {
              refresh();
              setActiveDialog({ ...activeDialog, show: false });
            });
          } else if (checkState.type == "suspend") {
            let sendState = {
              id: suspendDialog.id,
              active: checkState.state,
            };
            SuspendCluster(sendState, () => {
              refresh();
              setSuspendDialog({
                ...suspendDialog,
                show: false,
              });
            });
          }
        }}
      />
      <Dialog
        BackdropProps={{
          style: {
            // backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={activeDialog.show}
        onClose={() => setActiveDialog({ ...activeDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            فروش محصولات خوشه {activeDialog.title}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                setCheckState({
                  show: true,
                  name: "فعال کردن فروش محصولات ",
                  state: true,
                  type: "active",
                });
              }}
            >
              فعال
            </Button>
            <Button
              sx={{ mx: 2 }}
              variant="contained"
              color="error"
              onClick={() => {
                setCheckState({
                  show: true,
                  name: "غیرفعال کردن فروش محصولات ",
                  state: false,
                  type: "active",
                });
              }}
            >
              غیرفعال
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setActiveDialog({ ...activeDialog, show: false });
              }}
            >
              انصراف
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        BackdropProps={{
          style: {
            // backgroundColor: "transparent",
          },
        }}
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={suspendDialog.show}
        onClose={() => setSuspendDialog({ ...suspendDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            تعلیق محصولات خوشه {suspendDialog.title}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                setCheckState({
                  show: true,
                  name: " تعلیق محصولات ",
                  state: true,
                  type: "suspend",
                });
              }}
            >
              تعلیق
            </Button>
            <Button
              sx={{ mx: 2 }}
              variant="contained"
              color="error"
              onClick={() => {
                setCheckState({
                  show: true,
                  name: "عدم تعلیق محصولات ",
                  state: false,
                  type: "suspend",
                });
              }}
            >
              عدم تعلیق
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setSuspendDialog({ ...suspendDialog, show: false });
              }}
            >
              انصراف
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Detail>
  );
}
